module.exports = __webpack_public_path__ + "img/home-high-2.59d013dc.png";